<template>
  <div id="wrap">
    <Header />
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit">
        <h1>약관 및 정책</h1>
      </div>

      <div class="hp_productMain_contentWrap">
        <!-- Sidebar -->
        <div class="hp_productMain_contentSidebar">
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu">
              <li @click="setTermsAndPoliciesID(1)" :class="{ 'hp_productMain_contentMenu_active': 1 === statusData.termsAndPoliciesID }">
                <a>이용약관</a>
              </li>
              <li @click="setTermsAndPoliciesID(2)" :class="{ 'hp_productMain_contentMenu_active': 2 === statusData.termsAndPoliciesID }">
                <a>개인정보취급방침</a>
              </li>
              <li @click="setTermsAndPoliciesID(3)" :class="{ 'hp_productMain_contentMenu_active': 3 === statusData.termsAndPoliciesID }">
                <a>국내여행약관</a>
              </li>
              <li @click="setTermsAndPoliciesID(4)" :class="{ 'hp_productMain_contentMenu_active': 4 === statusData.termsAndPoliciesID }">
                <a>해외여행약관</a>
              </li>
              <li @click="setTermsAndPoliciesID(5)" :class="{ 'hp_productMain_contentMenu_active': 5 === statusData.termsAndPoliciesID }">
                <a>E-Mail수집거부</a>
              </li>
            </ul>
          </div>

          <!-- Hot Keywords -->
          <div class="hp_productMain_contentKeywordBox hp_MobNonePcBlock">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p v-for="item in statusData.hotKeywordData" :key="item.hot_keyword_ID">
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- 이용약관  -->
        <div class="hp_pageTermsWrap" v-if="statusData.termsAndPoliciesID === 1">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            이용약관
          </div>
          <div>
            <div class="hp_pageTerms_grayBoxMain">
              (주)행복을주는사람들은 공정거래위원회에서 심의한 표준약관 (공정거래위원회 표준약관 제10023호)을 사용하고 있습니다.
            </div>
            <h4>[제1조] 목적</h4>
            <p class="hp_pageTerms_txt">
              본 약관은 (주)행복을주는사람들 (이하 "회사")가 제공하는 모든 서비스의 이용조건 및 절차에 관한 사항과 기타 필요한 사항을 전기통신사업법 및 동법 시행령이 정하는 대로 준수하고 규정함을 목적으로 합니다.
            </p>
            <h4>[제2조] 약관의 효력과 변경</h4>
            <p class="hp_pageTerms_txt">
              1. 이 약관은 이용자에게 공시함으로써 효력을 발생합니다.<br />
              2. 회사는 사정 변경의 경우와 영업상 중요 사유가 있을 때 약관을 변경할 수 있으며, 변경된 약관은 전항과 같은 방법으로 효력을 발생합니다.
            </p>
            <h4>[제3조] 약관 외 준칙</h4>
            <p class="hp_pageTerms_txt">
              이 약관에 명시되지 않은 사항이 관계 법령에 규정되어 있을 경우에는 그 규정에 따릅니다.
            </p>
            <h4>[제4조] 서비스 이용 계약의 성립</h4>
            <p class="hp_pageTerms_txt">
              1. 이용 계약은 이용자의 회원등록 신청에 대한 회사의 이용 승낙과 이용자의 약관 내용에 대한 동의로 성립됩니다.<br />
              2. 회원에 가입하여 서비스를 이용하고자 하는 희망자는 회사에서 요청하는 개인 신상정보를 제공해야 합니다.<br />
              3. 이용자의 이용신청에 대하여 회사가 이를 승낙한 경우, 회사는 회원 ID와 기타 회사가 필요하다고 인정하는 내용을 이용자에게 통지합니다.<br />
              4. 회사는 다음 각 호에 해당하는 이용계약 신청에 대하여는 이를 승낙하지 아니 합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 다른 사람의 명의를 사용하여 신청하였을 때<br />
              나. 본인의 실명으로 신청하지 않았을 때<br />
              다. 이용 계약 신청서의 내용을 허위로 기재하였을 때<br />
              라. 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청하였을 때
            </div>
            <h4>[제5조] 회원가입</h4>
            <p class="hp_pageTerms_txt">
              1. 이용자는 회사가 정한 가입양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.<br />
              2. 이용자는 반드시 실명으로 회원가입을 하여야 하며, 1개의 이름에 대해 1건의 회원가입 신청을 할 수 있습니다.<br />
              3. 회원가입계약의 성립시기는 회사의 승낙이 이용자에게 도달한 시점으로 합니다.<br />
              4. 회원은 등록사항에 변경이 있는 경우 회원정보변경 항목을 통해 직접 변경사항을 수정, 등록하여야 합니다.<br />
              5. 회사는 제 1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 이름이 실명이 아닌 경우<br />
              나. 등록 내용에 허위, 기재누락, 오기가 있는 경우<br />
              다. 타인의 명의를 사용하여 신청한 경우<br />
              라. 가입신청자가 이 약관 제 8조 3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우 (단, 회원자격 상실 후 3년이 경과한 자로서 회사의 회원 재가입 승낙을 얻은 경우는 예외로 합니다.)<br />
              마. 만 14세 미만의 아동<br />
              바. 기타 회원으로 회사 소정의 이용신청요건을 충족하지 못하는 경우
            </div>
            <h4>[제6조] 회원탈퇴 및 자격 상실 등</h4>
            <p class="hp_pageTerms_txt">
              1. 회원은 언제든지 회원의 탈퇴를 홈페이지에 요청할 수 있으며, 홈페이지는 즉시 이에 응합니다.<br />
              2. 회사가 회원자격을 제한/정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실 시킬 수 있습니다.<br />
              3. 회사가 회원자격을 상실 시키는 경우 회원에게 이를 통지하고 탈퇴를 처리합니다. 이 경우 회원에게 이를 통지하고, 탈퇴 전에 소명할 기회를 부여합니다.<br />
              4. 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 가입 신청 시에 허위 내용을 등록한 경우<br />
              나. 타인의 서비스 이용을 방해하거나 그 정보를 도용하는 등 서비스 운영질서를 위협하는 경우<br />
              다. 서비스를 이용하여 법령과 이 약관이 금지하거나, 공서양속에 반하는 행위를 하는 경우<br />
              라. 제 13조 에 명기된 회원의 의무사항을 준수하지 못할 경우
            </div>
            <h4>[제7조] 이용자에 대한 통지</h4>
            <p class="hp_pageTerms_txt">
              1. 회사가 이용자에 대한 통지를 하는 경우, 이용자가 서비스에 제출한 전자우편 주소로 할 수 있습니다.<br />
              2. 회사가 불특정 다수 이용자에 대한 통지의 경우 1주일 이상 서비스 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.
            </p>
            <h4>[제8조] 회사의 의무</h4>
            <p class="hp_pageTerms_txt">
              1. 회사는 특별한 사정이 없는 한 회원이 신청한 서비스 제공 개시일에 서비스를 이용할 수 있도록 합니다.<br />
              2. 회사는 이 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 의무가 있습니다.<br />
              3. 회사는 회원으로부터 소정의 절차에 의해 제기되는 의견에 대해서는 적절한 절차를 거쳐 처리하며, 처리시 일정 기간이 소요될 경우 회원에게 그 사유와 처리 일정을 알려주어야 합니다.<br />
              4. 회사는 회원의 정보를 철저히 보안 유지하며, 양질의 서비스를 운영하거나 개선하는 데에만 사용하고, 이외의 다른 목적으로 타 기관 및 개인에게 양도하지 않습니다.
            </p>
            <h4>[제9조] 회원의 ID 및 비밀번호에 대한 의무</h4>
            <p class="hp_pageTerms_txt">
              1. 회원에게 부여된 아이디(ID)와 비밀번호의 관리책임은 회원에게 있으며 관리 소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br />
              2. 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제 3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.
            </p>
            <h4>[제10조] 회원의 의무</h4>
            <p class="hp_pageTerms_txt">
              1. ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있습니다.<br />
              2. 회원은 서비스의 일부로 보내지는 의 전자우편을 받는 것에 동의합니다.<br />
              3. 자신의 ID가 부정하게 사용된 경우, 회원은 반드시 회사에 그 사실을 통보해야 합니다.<br />
              4. 회원은 이 약관 및 관계 법령에서 규정한 사항을 준수하여야 합니다.
            </p>
            <h4>[제11조] 게시물 삭제</h4>
            <p class="hp_pageTerms_txt">
              회원이 게시하거나 등록한 내용물이 다음 사항에 해당된다고 판단되는 경우에 사전 통지 없이 삭제할 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 타인을 비방하거나 중상모략으로 개인 및 단체의 명예를 손상시키는 내용인 경우<br />
              나. 공공질서 및 미풍양속에 위반되는 내용인 경우<br />
              다. 범죄적 행위에 부합된다고 인정되는 내용인 경우<br />
              라. 타인의 저작권 등 기타의 권리를 침해하는 내용인 경우<br />
              마. 기타 관계 법령이나 회사에서 정한 규정에 위배되는 내용인 경우
            </div>
            <h4>[제12조] 게시물에 대한 권리 / 의무</h4>
            <p class="hp_pageTerms_txt">
              게시물에 대한 저작권을 포함한 모든 권리 및 책임은 이를 게시한 이용자에게 있습니다.
            </p>
            <h4>[제13조] 손해배상</h4>
            <p class="hp_pageTerms_txt">
              회사는 무료로 제공되는 서비스와 관련하여 이용자에게 어떠한 손해가 발생하더라도 동 손해가 회사의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부여하지 아니합니다.
            </p>
            <h4>[제14조] 분쟁의 해결</h4>
            <p class="hp_pageTerms_txt">
              1. 회사와 이용자는 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.<br />
              2. 1항의 규정에도 불구하고, 동 분쟁으로 인하여 소송이 제기될 경우 동 소송은 회사의 본사 소재지를 관할하는 법원을 관할법원으로 합니다.<br />
              3. 동 소송에는 대한민국 법을 적용합니다.
            </p>
            <h4>[제15조] 기타</h4>
            <p class="hp_pageTerms_txt">
              이 약관에 명시되지 아니한 사항의 처리를 위하여 이용자는 담당자에게 문의해주시면 됩니다.
            </p>
            <h4>[부칙]</h4>
            <p class="hp_pageTerms_txt">
              이 약관은 2015년 08월 01일부터 시행합니다.
            </p>
          </div>
        </div>
        <!-- 이용약관  -->

        <!-- 개인정보취급방침  -->
        <div class="hp_pageTermsWrap" v-if="statusData.termsAndPoliciesID === 2">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            (주)행복을주는사람들 개인정보취급방침
          </div>
          <div>
            <div class="hp_pageTerms_grayBoxMain">
              (주)행복을주는사람들은 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.
            </div>
            <p class="hp_pageTerms_txt">
              (주)행복을주는사람들은 (이하 "회사")은 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.<br />
              회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.<br />
              본 방침은 : 2015년 08월 01일 부터 시행됩니다.
            </p>
            <h4>개인정보의 처리 목적</h4>
            <p class="hp_pageTerms_txt">
              회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              ◦ <span class="hp_pageTerms_pointTxt">홈페이지 회원가입 및 관리</span> : 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지·통지, 고충처리 목적으로 개인정보를 처리합니다.<br />
              ◦ <span class="hp_pageTerms_pointTxt">재화 또는 서비스 제공</span> : 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 요금결제·정산을 목적으로 개인정보를 처리합니다.<br />
              ◦ <span class="hp_pageTerms_pointTxt">마케팅 및 광고에의 활용</span> : 신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공 , 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.
            </div>
            <h4>처리하는 개인정보 항목</h4>
            <p class="hp_pageTerms_txt">
              회사는 다음의 개인정보 항목을 처리하고 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[회원가입]</span><br />
              ◦ 필수항목 : 아이디, 비밀번호, 이름, E-Mail, 전화번호, 휴대폰번호, SMS 수신여부<br />
              ◦ 선택항목 : 주소
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[아이디/비밀번호찾기]</span><br />
              ◦ 필수항목 : 이름, 아이디, 휴대폰번호<br />
              ◦ 선택항목 : 없음
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[여행예약하기]</span><br />
              ◦ 필수항목 : 예약자명, 핸드폰번호, 전화번호, 실제여행자정보 (성명, 전화번호,생년월일), 무통장 입금 (입금자명)<br />
              ◦ 선택항목 : E-Mail, 실제여행자정보 (비고), 남기실말씀
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[게시판 - 글쓰기]</span><br />
              ◦ 필수항목 : 작성자 이름, 비밀번호<br />
              ◦ 선택항목 : E-Mail
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[예약/결제현황]</span><br />
              ◦ 필수항목 : 예약자명, 휴대폰번호<br />
              ◦ 선택항목 : 없음
            </div>
            <h4>수집하는 개인정보의 항목 및 수집방법</h4>
            <p class="hp_pageTerms_txt">
              회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              ◦ 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산<br />
              ◦ 콘텐츠 제공, 구매 및 요금 결제, 금융거래 본인 인증 및 금융 서비스<br />
              ◦ 회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 불량회원의 부정 이용 방지와 비인가 사용 방지 , 가입 의사 확인 , 연령확인 , 불만처리 등 민원처리 , 고지사항 전달
            </div>
            <h4>개인정보의 처리 및 보유기간</h4>
            <p class="hp_pageTerms_txt">
              원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br />
              단, 상법 및 '전자상거래등에서 소비자보호에 관한 법률' 등 관련 법령의 규정에 의하여 다음과 같이 거래 관련 관리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              ◦ 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년<br />
              ◦ 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년<br />
              ◦ 대금결제 및 재화 등의 공급에 관한 기록 : 5년<br />
              ◦ 계약 또는 청약철회 등에 관한 기록 : 5년<br />
              ◦ 표시/광고에 관한 기록 : 6개월<br />
              ◦ 설문조사, 이벤트 등 일시적 목적을 위하여 수집한 경우 : 당해 설문조사, 이벤트 등의 종료 시점
            </div>
            <h4>개인정보 파기 절차 및 방법</h4>
            <p class="hp_pageTerms_txt">
              회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[파기절차]</span><br />
              이용자가 서비스 이용 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[파기방법]</span><br />
              ◦ 종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각<br />
              ◦ 전자적 파일 형태로 저장된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제
            </div>
            <h4>개인정보의 제3자 제공</h4>
            <p class="hp_pageTerms_txt">
              회사는 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[항공사 및 해운업체]</span><br />
              ◦ 개인정보를 제공받는 자 : 항공사 및 해운업체<br />
              ◦ 제공항목 : 휴대전화번호, 성별, 생년월일, 이름<br />
              ◦ 제공받는 자의 이용 목적 : 탑승예약<br />
              ◦ 제공받는 자의 보유.이용기간: 이용 목적 달성 및 관계법령 (전자상거래 등에서의 소비자보호에 관한 법률)에 따른 보관기간까지
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[호텔 및 숙박업체]</span><br />
              ◦ 개인정보를 제공받는 자 : 호텔 및 숙박업체<br />
              ◦ 제공항목 : 휴대전화번호, 이름<br />
              ◦ 제공받는 자의 이용 목적 : 숙박예약<br />
              ◦ 제공받는 자의 보유.이용기간: 이용 목적 달성 및 관계법령 (전자상거래 등에서의 소비자보호에 관한 법률)에 따른 보관기간까지
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[결제대행사]</span><br />
              ◦ 개인정보를 제공받는 자 : 결제대행사<br />
              ◦ 제공항목 : 휴대전화번호, 이메일, 이름<br />
              ◦ 제공받는 자의 이용 목적 : 결제서비스<br />
              ◦ 제공받는 자의 보유.이용기간: 이용 목적 달성 및 관계법령 (전자상거래 등에서의 소비자보호에 관한 법률)에 따른 보관기간까지
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[이용자들이 사전에 동의한 경우]</span><br />
              ◦ 정보수집 또는 정보제공 이전에 회원님께 비즈니스 파트너가 누구인지, 어떤 정보가 왜 필요한지, 그리고 언제까지 어떻게 보호/관리되는지 알려드리고 동의를 구하는 절차를 거치게 되며, 회원님께서 동의하지 않는 경우에는 추가적인 정보를 수집하거나 비즈니스 파트너와 공유하지 않습니다.<br />
              ◦ 예외 : 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
            </div>
            <h4>정보주체와 법정대리인의 권리와 그 행사방법</h4>
            <p class="hp_pageTerms_txt">
              1. 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 동의철회(가입해지)를 요청할 수도 있습니다.<br />
              2. 이용자의 개인정보 조회.수정을 위해서는 로그인 후 '마이페이지' 에서 '회원정보수정'을 가입 해지(동의철회)를 위해서는 회사에 서면, 전화 또는 E-Mail로 연락하시면 본인 확인 절차를 거친 후 지체 없이 조치하겠습니다.<br />
              3. 귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.<br />
              4. 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 "회사가 수집하는 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[회원탈퇴 처리방법]</span><br />
              ◦ 사이트 접속 → 로그인 → 마이페이지 → 회원탈퇴를 통하여 탈퇴신청을 할 수 있습니다.<br />
              ◦ 또는 고객상담센터로 전화 요청시 즉시 탈퇴 신청을 하실 수 있습니다.
            </div>
            <h4>개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h4>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[쿠키 등 사용 목적]</span><br />
              ◦ 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공<br />
              ◦ 귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[쿠키 설정 거부 방법]</span><br />
              쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.<br />
              <span class="hp_pageTerms_boldTxt">◦ Internet Explorer (인터넷 익스플로러)를 사용하는 경우</span>
              <p class="hp_pageTerms_marginLeftBox">
                1. [도구] 메뉴에서 [인터넷옵션]을 클릭합니다.<br />
                2. [개인정보]탭을 클릭합니다.<br />
                3. 개인정보 설정수준을 사용자 조정하시면 됩니다.
              </p>
              <span class="hp_pageTerms_boldTxt">◦ Chrome (크롬) 를 사용하는 경우</span>
              <p class="hp_pageTerms_marginLeftBox">
                1. 오른쪽 상단에서 더보기 설정을 클릭합니다.<br />
                2. 하단에서 고급을 클릭합니다.<br />
                3. [개인정보 보호 및 보안]에서 콘텐츠 설정을 클릭합니다.<br />
                4. 쿠키를 클릭합니다.<br />
                5. 사이트에서 쿠키 데이터 저장 및 읽기 허용을 사용 또는 사용 중지합니다.
              </p>
            </div>
            <h4>개인정보관리책임자 및 담당자의 연락처</h4>
            <p class="hp_pageTerms_txt">
              귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
            </p>
            <div>
              <br/>
              <span class="hp_pageTerms_pointTxt">[개인정보 관리책임자]</span>
              <table border="0" cellspacing="0" cellpadding="0" summary="개인정보 관리책임자" class="hp_pageTerms_table">
                <caption>개인정보 관리책임자</caption>
                <colgroup>
                  <col width="15%">
                  <col width="35%">
                  <col width="15%">
                  <col width="35%">
                </colgroup>
                <tbody>
                  <tr>
                    <th>이 름</th>
                    <td class="hp_pageTerms_tableLeft">배성준</td>
                    <th>부 서 </th>
                    <td class="hp_pageTerms_tableLeft">고객지원팀</td>
                  </tr>
                  <tr>
                    <th>전화번호</th>
                    <td class="hp_pageTerms_tableLeft">02-3273-3311</td>
                    <th>직 위</th>
                    <td class="hp_pageTerms_tableLeft">대표이사</td>
                  </tr>
                  <tr>
                    <th>E-Mail</th>
                    <td colspan="3" class="hp_pageTerms_tableLeft">happy85922@nate.com</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <br/>
              <span class="hp_pageTerms_pointTxt">[개인정보 담당부서]</span>
              <table border="0" cellspacing="0" cellpadding="0" summary="개인정보 담당부서" class="hp_pageTerms_table">
              <caption>개인정보 담당부서</caption>
                <colgroup>
                  <col width="15%">
                  <col width="35%">
                  <col width="15%">
                  <col width="35%">
                </colgroup>
                <tbody>
                  <tr>
                    <th>부 서</th>
                    <td class="hp_pageTerms_tableLeft">고객지원팀</td>
                    <th>전화번호</th>
                    <td class="hp_pageTerms_tableLeft">02-3273-3311</td>
                  </tr>
                  <tr>
                    <th>E-Mail</th>
                    <td colspan="3" class="hp_pageTerms_tableLeft">ktx7787@hanmail.net</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="hp_pageTerms_txt">
              기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              ◦ 개인정보침해신고센터 (www.118.or.kr / 118)<br />
              ◦ 정보보호마크인증위원회 (www.eprivacy.or.kr / 02-580-0533~4)<br />
              ◦ 대검찰청 첨단범죄수사과 (www.spo.go.kr / 02-3480-2000)<br />
              ◦ 경찰청 사이버테러대응센터 (www.ctrc.go.kr / 02-392-0330)
            </div>
            <h4>개인정보의 안전성 확보 조치</h4>
            회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.<br /><br />
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_boldTxt">가. 비밀번호 암호화</span>
              <p class="hp_pageTerms_marginLeftBox">
                회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
              </p>
              <span class="hp_pageTerms_boldTxt">나. 해킹 등에 대비한 대책</span>
              <p class="hp_pageTerms_marginLeftBox">
                회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.<br />
                개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신(SSL) 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.
              </p>
              <span class="hp_pageTerms_boldTxt">다. 취급 직원의 최소화 및 교육</span>
              <p class="hp_pageTerms_marginLeftBox">
                회사의 개인정보관련 취급 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사의 웹 사이트 개인정보취급방침의 준수를 항상 강조하고 있습니다.
              </p>
              <span class="hp_pageTerms_boldTxt">라. 개인정보보호전담기구의 운영</span>
              <p class="hp_pageTerms_marginLeftBox">
                사내 개인정보보호 회의 등을 통하여 회사의 웹 사이트 개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.
              </p>
            </div>
            <h4>개인 아이디와 비밀번호 관리</h4>
            <p class="hp_pageTerms_txt">
              1. 회원님이 사용하고 계시는 ID와 비밀번호는 원칙적으로 회원님만이 사용하도록 되어 있습니다.<br />
              2. 회사의 고의 또는 과실이 없는 경우에, 회원님의 ID와 비밀번호 도용 또는 기타 타인의 사용으로 인해 발생된 문제에 대하여 회사가 책임지지 않습니다.<br />
              3. 어떠한 경우에도 비밀번호는 타인에게 알려 주지 마시고 로그온 상태에서는 주위의 다른 사람에게 개인 정보가 유출되지 않도록 특별한 주의를 기울여 주시기 바랍니다.<br />
              4. 타인의 개인정보를 도용하여 회원 가입 또는 서비스 이용이 확인되었을 경우에는 이용계약이 일방적으로 해지될 수 있습니다.
            </p>
            <h4>기 타</h4>
            <p class="hp_pageTerms_txt">
              본 사이트에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 "본 사이트 개인정보취급방침"이 적용되지 않음을 알려 드립니다.
            </p>
            <h4>고지의 의무</h4>
            <p class="hp_pageTerms_txt">
              현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              ◦ 개인정보취급방침 버전번호 : v1.0<br />
              ◦ 공고일자 : 2015/08/01<br />
              ◦ 시행일자 : 2015/08/01
            </div>
          </div>
        </div>
        <!-- 개인정보취급방침  -->

        <!-- 국내여행약관  -->
        <div class="hp_pageTermsWrap" v-if="statusData.termsAndPoliciesID === 3">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            국내여행약관
          </div>
          <div>
            <div class="hp_pageTerms_grayBoxMain">
              (주)행복을주는사람들은 공정거래위원회 국내여행 표준약관 제10020호를 사용합니다.
            </div>
            <h4>[제1조] 목적</h4>
            <p class="hp_pageTerms_txt">
              이 약관은 (주)행복을주는사람들 (이하 "회사"라 한다)과 여행자가 체결한 국내여행계약의 세부이행 및 준수사항을 정함을 목적으로 합니다.
            </p>
            <h4>[제2조] 여행의 종류 및 정의</h4>
            <p class="hp_pageTerms_txt">
              여행의 종류와 정의는 다음과 같습니다.<br />
              1. 일반모집여행 : 여행사가 수립한 여행조건에 따라 여행자를 모집하여 실시하는 여행<br />
              2. 희망여행 : 여행자가 희망하는 여행조건에 따라 여행사가 실시하는 여행<br />
              3. 위탁모집여행 : 여행사가 만든 모집여행상품의 여행자 모집을 타 여행업체에 위탁하여 실시하는 여행
            </p>
            <h4>[제3조] 여행사와 여행자 의무</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사는 여행자에게 안전하고 만족스러운 여행서비스를 제공하기 위하여 여행알선 및 안내/운송/숙박 등 여행계획의 수립 및 실행과정에서 맡은 바 임무를 충실히 수행하여야 합니다.<br />
              2. 여행자는 안전하고 즐거운 여행을 위하여 여행자간 화합도모 및 여행사의 여행질서 유지에 적극 협조하여야 합니다.
            </p>
            <h4>[제4조] 계약의 구성</h4>
            <p class="hp_pageTerms_txt">
              1. 여행계약은 여행계약서 (붙임)와 여행약관, 여행일정표 (또는 여행 설명서)를 계약내용으로 합니다.<br />
              2. 여행계약서에는 여행사의 상호, 소재지 및 관광진흥법 제9조에 따른 보증보험 등의 가입 (또는 영업보증금의 예치 현황) 내용이 포함되어야 합니다.<br />
              3. 여행일정표 (또는 여행설명서)에는 여행일자별 여행지와 관광내용,교통수단,쇼핑횟수,숙박장소,식사 등 여행실시일정 및 여행사 제공 서비스 내용과 여행자 유의사항이 포함되어야 합니다.
            </p>
            <h4>[제5조] 계약체결 거절</h4>
            <p class="hp_pageTerms_txt">
              여행사는 여행자에게 다음 각 호의 1에 해당하는 사유가 있을 경우에는 여행자와의 계약체결을 거절할 수 있습니다.<br />
              가. 질병, 신체이상 등의 사유로 개별관리가 필요하거나, 단체여행(다른 여행자의 여행에 지장을 초래하는 등)의 원활한 실시에 지장이 있다고 인정되는 경우<br />
              나. 계약서에 명시한 최대행사인원이 초과된 경우
            </p>
            <h4>[제6조] 특약</h4>
            <p class="hp_pageTerms_txt">
              여행사와 여행자는 관련법규에 위반되지 않는 범위 내에서 서면 (전자문서를 포함한다. 이하 같다)으로 특약을 맺을 수 있습니다. 이 경우 여행사는 특약의 내용이 표준약관과 다르고 표준약관보다 우선 적용됨을 여행자에게 설명하고 별도의 확인을 받아야 합니다.
            </p>
            <h4>[제7조] 계약서 등 교부 및 안전정보 제공</h4>
            <p class="hp_pageTerms_txt">
              여행사는 여행자와 여행계약을 체결한 경우 계약서와 여행약관, 여행일정표(또는 여행설명서)를 각 1부씩 여행자에게 교부하고, 여행목적지에 관한 안전정보를 제공하여야 합니다. 또한 여행 출발 전 해당 여행지에 대한 안전정보가 변경된 경우에도 변경된 안전정보를 제공하여야 합니다.
            </p>
            <h4>[제8조] 계약서 및 약관 등 교부 간주</h4>
            <p class="hp_pageTerms_txt">
              다음 각 호의 경우에는 여행사가 여행자에게 여행계약서와 여행약관 및 여행일정표(또는 여행설명서)가 교부된 것으로 간주합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 여행자가 인터넷 등 전자정보망으로 제공된 여행계약서, 약관 및 여행일정표(또는 여행설명서)의 내용에 동의하고 여행계약의 체결을 신청한 데 대해 여행사가 전자정보망 내지 기계적 장치 등을 이용하여 여행자에게 승낙의 의사를 통지한 경우<br />
              나. 여행사가 팩시밀리 등 기계적 장치를 이용하여 제공한 여행계약서, 약관 및 여행일정표(또는 여행설명서)의 내용에 대하여 여행자가 동의하고 여행계약의 체결을 신청하는 서면을 송부한 데 대해 여행사가 전자정보망 내지 기계적 장치 등을 이용하여 여행자에게 승낙의 의사를 통지한 경우
            </div>
            <h4>[제9조] 여행요금</h4>
            <p class="hp_pageTerms_txt">
              1. 여행계약서의 여행요금에는 다음 각 호가 포함됩니다. 다만, 희망여행은 당사자간 합의에 따릅니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 항공기, 선박, 철도 등 이용운송기관의 운임(보통운임기준)<br />
              나. 공항, 역, 부두와 호텔사이 등 송영버스요금<br />
              다. 숙박요금 및 식사요금<br />
              라. 안내자경비<br />
              마. 여행 중 필요한 각종 세금<br />
              바. 국내 공항,항만 이용료<br />
              사. 일정표내 관광지 입장료<br />
              아. 기타 개별계약에 따른 비용
            </div>
            <p class="hp_pageTerms_txt">
              2. 여행자는 계약 체결시 계약금(여행요금 중 10%이하의 금액)을 여행사에게 지급하여야 하며, 계약금은 여행요금 또는 손해배상액의 전부 또는 일부로 취급합니다.<br />
              3. 여행자는 제1항의 여행요금 중 계약금을 제외한 잔금을 여행출발 전일까지 여행사에게 지급하여야 합니다.<br />
              4. 여행자는 제1항의 여행요금을 당사자가 약정한 바에 따라 카드, 계좌이체 또는 무통장 입금 등의 방법으로 지급하여야 합니다.<br />
              5. 희망여행요금에 여행자 보험료가 포함되는 경우 여행사는 보험회사명, 보상내용 등을 여행자에게 설명하여야 합니다.
            </p>
            <h4>[제10조] 여행조건의 변경요건 및 요금 등의 정산</h4>
            <p class="hp_pageTerms_txt">
              1. 계약서 등에 명시된 여행조건은 다음 각 호의 1의 경우에 한하여 변경될 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 여행자의 안전과 보호를 위하여 여행자의 요청 또는 현지사정에 의하여 부득이하다고 쌍방이 합의한 경우<br />
              나. 천재지변, 전란, 정부의 명령, 운송,숙박기관 등의 파업,휴업 등으로 여행의 목적을 달성할 수 없는 경우
            </div>
            <p class="hp_pageTerms_txt">
              2. 여행사가 계약서 등에 명시된 여행일정을 변경하는 경우에는 해당 날짜의 일정이 시작되기 전에 여행자의 서면 동의를 받아야 합니다. 이때 서면동의서에는 변경일시, 변경내용, 변경으로 발생하는 비용이 포함되어야 합니다.<br />
              3. 천재지변, 사고, 납치 등 긴급한 사유가 발생하여 여행자로부터 여행일정 변경 동의를 받기 어렵다고 인정되는 경우에는 제2항에 따른 일정변경 동의서를 받지 아니할 수 있습니다. 다만, 여행사는 사후에 서면으로 그 변경 사유 및 비용 등을 설명하여야 합니다.<br />
              4. 제1항의 여행조건 변경으로 인하여 제9조제1항의 여행요금에 증감이 생기는 경우에는 여행출발 전 변경 분은 여행출발 이전에, 여행 중 변경 분은 여행종료 후 10일 이내에 각각 정산(환급)하여야 합니다.<br />
              5. 제1항의 규정에 의하지 아니하고 여행조건이 변경되거나 제13조 내지 제15조의 규정에 의한 계약의 해제,해지로 인하여 손해배상액이 발생한 경우에는 여행출발 전 발생 분은 여행출발이전에, 여행 중 발생 분은 여행종료 후 10일 이내에 각각 정산(환급)하여야 합니다.<br />
              6. 여행자는 여행출발 후 자기의 사정으로 숙박, 식사, 관광 등 여행요금에 포함된 서비스를 제공받지 못한 경우 여행사에게 그에 상응하는 요금의 환급을 청구할 수 없습니다. 다만, 여행이 중도에 종료된 경우에는 제15조에 준하여 처리합니다.
            </p>
            <h4>[제11조] 여행자 지위의 양도</h4>
            <p class="hp_pageTerms_txt">
              1. 여행자가 개인사정 등으로 여행자의 지위를 양도하기 위해서는 여행사의 승낙을 받아야 합니다. 이때 여행사는 여행자 또는 여행자의 지위를 양도받으려는 자가 양도로 발생하는 비용을 지급할 것을 조건으로 양도를 승낙할 수 있습니다.<br />
              2. 전항의 양도로 발생하는 비용이 있을 경우 여행사는 기한을 정하여 그 비용의 지급을 청구하여야 합니다.<br />
              3. 여행사는 계약조건 또는 양도하기 어려운 불가피한 사정 등을 이유로 제1항의 양도를 승낙하지 않을 수 있습니다.<br />
              4. 제1항의 양도는 여행사가 승낙한 때 효력이 발생합니다. 다만, 여행사가 양도로 인해 발생한 비용의 지급을 조건으로 승낙한 경우에는 정해진 기한 내에 비용이 지급되는 즉시 효력이 발생합니다.<br />
              5. 여행자의 지위가 양도되면, 여행계약과 관련한 여행자의 모든 권리 및 의무도 그 지위를 양도 받는 자에게 승계됩니다.
            </p>
            <h4>[제12조] 여행사의 책임</h4>
            <p class="hp_pageTerms_txt">
              1. 여행자는 여행에 하자가 있는 경우에 여행사에게 하자의 시정 또는 대금의 감액을 청구할 수 있습니다. 다만, 그 시정에 지나치게 많은 비용이 들거나 그 밖에 시정을 합리적으로 기대할 수 없는 경우에는 시정을 청구할 수 없습니다.<br />
              2. 여행자는 시정 청구, 감액 청구를 갈음하여 손해배상을 청구하거나 시정 청구, 감액 청구와 함께 손해배상을 청구 할 수 있습니다.<br />
              3. 제1항 및 제2항의 권리는 여행기간 중에도 행사할 수 있으며, 여행종료일부터 6개월 내에 행사하여야 합니다.<br />
              4. 여행사는 여행 출발시부터 도착시까지 여행사 본인 또는 그 고용인, 현지여행사 또는 그 고용인 등(이하 "사용인"이라 함)이 제3조제1항에서 규정한 여행사 임무와 관련하여 여행자에게 고의 또는 과실로 손해를 가한 경우 책임을 집니다.<br />
              5. 여행사는 항공기, 기차, 선박 등 교통기관의 연발착 또는 교통체증 등으로 인하여 여행자가 입은 손해를 배상하여야 합니다. 다만, 여행사가 고의 또는 과실이 없음을 입증한 때에는 그러하지 아니합니다.<br />
              6. 여행사는 자기나 그 사용인이 여행자의 수하물 수령,인도,보관 등에 관하여 주의를 해태하지 아니하였음을 증명하지 아니 하는 한 여행자의 수하물 멸실, 훼손 또는 연착으로 인하여 발생한 손해를 배상하여야 합니다.
            </p>
            <h4>[제13조] 여행출발 전 계약해제</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사 또는 여행자는 여행출발전 이 여행계약을 해제할 수 있습니다. 이 경우 발생하는 손해액은 "소비자분쟁해결기준"(공정거래위원회 고시)에 따라 배상합니다.<br />
              2. 여행사 또는 여행자는 여행출발 전에 다음 각 호의 1에 해당하는 사유가 있는 경우 상대방에게 제1항의 손해배상액을 지급하지 아니하고 이 여행계약을 해제할 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">1. 여행업자가 해제할 수 있는 경우</span>
              <p class="hp_pageTerms_marginLeftBox">
                가. 제10조 제1항 제1호 및 제2호 사유의 경우<br />
                나. 여행자가 다른 여행자에게 폐를 끼치거나 여행의 원활한 실시에 현저한 지장이 있다고 인정될 때<br />
                다. 질병 등 여행자의 신체에 이상이 발생하여 여행에의 참가가 불가능한 경우<br />
                라. 여행자가 계약서에 기재된 기일까지 여행요금을 지급하지 아니하는 경우
              </p>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">2. 여행자가 해제할 수 있는 경우</span>
              <p class="hp_pageTerms_marginLeftBox">
                가. 제10조 제1항 제1호 및 제2호 사유의 경우<br />
                나. 여행사가 제18조에 따른 공제 또는 보증보험에 가입하지 아니 하였거나 영업보증금을 예치하지 않은 경우<br />
                다. 여행자의 3촌이내 친족이 사망한 경우<br />
                라. 질병 등 여행자의 신체에 이상이 발생하여 여행에의 참가가 불가능한 경우<br />
                마. 배우자 또는 직계 존비속이 신체 이상으로 3일 이상 병원 (의원)에 입원하여 여행 출발 시 까지 퇴원이 곤란한 경우 그 배우자 또는 보호자 1인<br />
                바. 여행사의 귀책 사유로 계약서에 기재된 여행 일정대로의 여행 실시가 불가능해진 경우
              </p>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[예약취소 및 변경]</span><br />
              예약하신 상품의 예약취소와 변경은 근무시간에 전화로만 가능합니다.<br />
              (평일 : 오전 9:00 ~ 오후 18:00 / 토요일,일요일 공휴일 휴무)<br />
              <span classs="hp_pageTerms_pointRed">※근무시간 이외,주말,공휴일에는 여행의 취소,변경은 처리되지 않습니다.</span>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[국내환불규정]</span><br />
              1. 출발 4일전 취소 및 변경 (인원,날짜변경)시 전체 여행경비의 100% 환불<br />
              2. 출발 3일전 취소 및 변경 (인원,날짜변경)시 전체 여행경비의 80% 환불<br />
              3. 출발 2일전 취소 및 변경 (인원,날짜변경)시 전체 여행경비의 50% 환불<br />
              4. 출발 1일전, 당일 취소 및 변경 (인원,날짜변경)시 환불절대불가
            </div>
            <h4>[제14조] 최저행사인원 미 충족시 계약해제</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사는 최저행사인원이 충족되지 아니하여 여행계약을 해제하는 경우 당일여행의 경우 여행출발 24시간 이전까지, 1박2일 이상인 경우에는 여행출발 48시간 이전까지 여행자에게 통지하여야 합니다.<br />
              2. 여행사가 여행참가자 수의 미달로 전항의 기일 내 통지를 하지 아니하고 계약을 해제하는 경우 이미 지급받은 계약금 환급 외에 계약금 100% 상당액을 여행자에게 배상하여야 합니다.
            </p>
            <h4>[제15조] 여행출발 후 계약해지</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사 또는 여행자는 여행출발 후 부득이한 사유가 있는 경우 각 당사자는 여행계약을 해지할 수 있습니다. 다만, 그 사유가 당사자 한쪽의 과실로 인하여 생긴 경우에는 상대방에게 손해를 배상하여야 합니다.<br />
              2. 제1항에 따라 여행계약이 해지된 경우 귀환운송 의무가 있는 여행사는 여행자를 귀환운송 할 의무가 있습니다.<br />
              3. 제1항의 계약해지로 인하여 발생하는 추가 비용은 그 해지사유가 어느 당사자의 사정에 속하는 경우에는 그 당사자가 부담하고, 양 당사자 누구의 사정에도 속하지 아니하는 경우에는 각 당사자가 추가 비용의 50%씩을 부담합니다.<br />
              4. 여행자는 여행에 중대한 하자가 있는 경우에 그 시정이 이루어지지 아니하거나 계약의 내용에 따른 이행을 기대할 수 없는 경우에는 계약을 해지할 수 있습니다.<br />
              5. 제4항에 따라 계약이 해지된 경우 여행사는 대금청구권을 상실합니다. 다만, 여행자가 실행된 여행으로 이익을 얻은 경우에는 그 이익을 여행사에게 상환하여야 합니다.<br />
              6. 제4항에 따라 계약이 해지된 경우 여행사는 계약의 해지로 인하여 필요하게 된 조치를 할 의무를 지며, 계약상 귀환운송 의무가 있으면 여행자를 귀환운송하여야 합니다. 이 경우 귀환운송비용은 원칙적으로 여행사가 부담하여야 하나, 상당한 이유가 있는 때에는 여행사는 여행자에게 그 비용의 일부를 청구할 수 있습니다.
            </p>
            <h4>[제16조] 여행의 시작과 종료</h4>
            <p class="hp_pageTerms_txt">
              여행의 시작은 출발하는 시점부터 시작하며 여행일정이 종료하여 최종목적지에 도착함과 동시에 종료합니다. 다만, 계약 및 일정을 변경할 때에는 예외로 합니다.
            </p>
            <h4>[제17조] 설명의무</h4>
            <p class="hp_pageTerms_txt">
              여행사는 이 계약서에 정하여져 있는 중요한 내용 및 그 변경사항을 여행자가 이해할 수 있도록 설명하여야 합니다.
            </p>
            <h4>[제18조] 보험가입 등</h4>
            <p class="hp_pageTerms_txt">
              여행사는 여행과 관련하여 여행자에게 손해가 발생 한 경우 여행자에게 보험금을 지급하기 위한 보험 또는 공제에 가입하거나 영업 보증금을 예치하여야 합니다.
            </p>
            <h4>[제19조] 기타사항</h4>
            <p class="hp_pageTerms_txt">
              1. 이 계약에 명시되지 아니한 사항 또는 이 계약의 해석에 관하여 다툼이 있는 경우에는 여행사와 여행자가 합의하여 결정하되, 합의가 이루어지지 아니한 경우에는 관계법령 및 일반관례에 따릅니다.<br />
              2. 특수지역에의 여행으로서 정당한 사유가 있는 경우에는 이 표준약관의 내용과 다르게 정할 수 있습니다.
            </p>
          </div>
        </div>
        <!-- 국내여행약관  -->

        <!-- 해외여행약관  -->
        <div class="hp_pageTermsWrap" v-if="statusData.termsAndPoliciesID === 4">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            해외여행약관
          </div>
          <div>
            <div class="hp_pageTerms_grayBoxMain">
              (주)행복을주는사람들은 공정거래위원회 국내여행 표준약관 제10021호를 사용합니다.
            </div>
            <h4>[제1조] 목적</h4>
            <p class="hp_pageTerms_txt">
              이 약관은 (주)행복을주는사람들 (이하 "회사"라 한다)과 여행자가 체결한 국외여행계약의 세부이행 및 준수사항을 정함을 목적으로 합니다.
            </p>
            <h4>[제2조] 용어의 정의</h4>
            <p class="hp_pageTerms_txt">
              여행의 종류 및 정의, 해외여행수속대행업의 정의는 다음과 같습니다.<br />
              1. 기획여행 : 여행사가 미리 여행목적지 및 관광일정, 여행자에게 제공될 운송 및 숙식서비스 내용(이하 "여행서비스"라 함), 여행요금을 정하여 광고 또는 기타 방법으로 여행자를 모집하여 실시하는 여행<br />
              2. 희망여행 : 여행자(개인 또는 단체)가 희망하는 여행조건에 따라 여행사가 운송,숙식,관광 등 여행에 관한 전반적인 계획을 수립하여 실시하는 여행<br />
              3. 해외여행 수속대행(이하 "수속대행계약"이라 함) : 여행사가 여행자로부터 소정의 수속대행요금을 받기로 약정하고, 여행자의 위탁에 따라 다음에 열거하는 업무(이하 "수속대행업무"라 함)를 대행하는 것
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 사증, 재입국 허가 및 각종 증명서 취득에 관한 수속<br />
              나. 입국 수속서류 작성 및 기타 관련업무
            </div>
            <h4>[제3조] 여행사와 여행자 의무</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사는 여행자에게 안전하고 만족스러운 여행서비스를 제공하기 위하여 여행알선 및 안내/운송/숙박 등 여행계획의 수립 및 실행과정에서 맡은 바 임무를 충실히 수행하여야 합니다.<br />
              2. 여행자는 안전하고 즐거운 여행을 위하여 여행자간 화합도모 및 여행사의 여행질서 유지에 적극 협조하여야 합니다.
            </p>
            <h4>[제4조] 계약의 구성</h4>
            <p class="hp_pageTerms_txt">
              1. 여행계약은 여행계약서 (붙임)와 여행약관, 여행일정표 (또는 여행 설명서)를 계약내용으로 합니다.<br />
              2. 여행계약서에는 여행사의 상호, 소재지 및 관광진흥법 제9조에 따른 보증보험 등의 가입 (또는 영업보증금의 예치 현황) 내용이 포함되어야 합니다.<br />
              3. 여행일정표 (또는 여행설명서)에는 여행일자별 여행지와 관광내용,교통수단,쇼핑횟수,숙박장소,식사 등 여행실시일정 및 여행사 제공 서비스 내용과 여행자 유의사항이 포함되어야 합니다.
            </p>
            <h4>[제5조] 계약체결 거절</h4>
            <p class="hp_pageTerms_txt">
              여행사는 여행자에게 다음 각 호의 1에 해당하는 사유가 있을 경우에는 여행자와의 계약체결을 거절할 수 있습니다.<br />
              가. 질병, 신체이상 등의 사유로 개별관리가 필요하거나, 단체여행(다른 여행자의 여행에 지장을 초래하는 등)의 원활한 실시에 지장이 있다고 인정되는 경우<br />
              나. 계약서에 명시한 최대행사인원이 초과된 경우
            </p>
            <h4>[제6조] 특약</h4>
            <p class="hp_pageTerms_txt">
              여행사와 여행자는 관련법규에 위반되지 않는 범위 내에서 서면 (전자문서를 포함한다. 이하 같다)으로 특약을 맺을 수 있습니다. 이 경우 여행사는 특약의 내용이 표준약관과 다르고 표준약관보다 우선 적용됨을 여행자에게 설명하고 별도의 확인을 받아야 합니다.
            </p>
            <h4>[제7조] 계약서 등 교부 및 안전정보 제공</h4>
            <p class="hp_pageTerms_txt">
              여행사는 여행자와 여행계약을 체결한 경우 계약서와 여행약관, 여행일정표(또는 여행설명서)를 각 1부씩 여행자에게 교부하고, 여행목적지에 관한 안전정보를 제공하여야 합니다. 또한 여행 출발 전 해당 여행지에 대한 안전정보가 변경된 경우에도 변경된 안전정보를 제공하여야 합니다.
            </p>
            <h4>[제8조] 계약서 및 약관 등 교부 간주</h4>
            <p class="hp_pageTerms_txt">
              다음 각 호의 경우에는 여행사가 여행자에게 여행계약서와 여행약관 및 여행일정표(또는 여행설명서)가 교부된 것으로 간주합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 여행자가 인터넷 등 전자정보망으로 제공된 여행계약서, 약관 및 여행일정표(또는 여행설명서)의 내용에 동의하고 여행계약의 체결을 신청한 데 대해 여행사가 전자정보망 내지 기계적 장치 등을 이용하여 여행자에게 승낙의 의사를 통지한 경우<br />
              나. 여행사가 팩시밀리 등 기계적 장치를 이용하여 제공한 여행계약서, 약관 및 여행일정표(또는 여행설명서)의 내용에 대하여 여행자가 동의하고 여행계약의 체결을 신청하는 서면을 송부한 데 대해 여행사가 전자정보망 내지 기계적 장치 등을 이용하여 여행자에게 승낙의 의사를 통지한 경우
            </div>
            <h4>[제9조] 여행사의 책임</h4>
            <p class="hp_pageTerms_txt">
              여행사는 여행 출발시부터 도착시까지 여행사 본인 또는 그 고용인, 현지여행사 또는 그 고용인 등(이하 "사용인"이라 함)이 제3조제1항에서 규정한 여행사 임무와 관련하여 여행자에게 고의 또는 과실로 손해를 가한 경우 책임을 집니다.
            </p>
            <h4>[제10조] 여행요금</h4>
            <p class="hp_pageTerms_txt">
              1. 여행계약서의 여행요금에는 다음 각 호가 포함됩니다. 다만, 희망여행은 당사자간 합의에 따릅니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 항공기, 선박, 철도 등 이용운송기관의 운임(보통운임기준)<br />
              나. 공항, 역, 부두와 호텔사이 등 송영버스요금<br />
              다. 숙박요금 및 식사요금<br />
              라. 안내자경비<br />
              마. 여행 중 필요한 각종 세금<br />
              바. 국내 공항,항만 이용료<br />
              사. 일정표내 관광지 입장료<br />
              아. 기타 개별계약에 따른 비용
            </div>
            <p class="hp_pageTerms_txt">
              2. 제1항에도 불구하고 반드시 현지에서 지불해야 하는 경비가 있는 경우 그 내역과 금액을 여행계약서에 별도로 구분하여 표시하고, 여행사는 그 사유를 안내하여야 합니다.<br />
              3. 여행자는 계약 체결시 계약금(여행요금 중 10%이하의 금액)을 여행사에게 지급하여야 하며, 계약금은 여행요금 또는 손해배상액의 전부 또는 일부로 취급합니다.<br />
              4. 여행자는 제1항의 여행요금 중 계약금을 제외한 잔금을 여행출발 전일까지 여행사에게 지급하여야 합니다.<br />
              5. 여행자는 제1항의 여행요금을 당사자가 약정한 바에 따라 카드, 계좌이체 또는 무통장 입금 등의 방법으로 지급하여야 합니다.<br />
              6. 희망여행요금에 여행자 보험료가 포함되는 경우 여행사는 보험회사명, 보상내용 등을 여행자에게 설명하여야 합니다.
            </p>
            <h4>[제11조] 여행요금의 변경</h4>
            <p class="hp_pageTerms_txt">
              1. 국외여행을 실시함에 있어서 이용운송,숙박기관에 지급하여야 할 요금이 계약체결시보다 5%이상 증감하거나 여행요금에 적용된 외화환율이 계약체결시보다 2% 이상 증감한 경우 여행사 또는 여행자는 그 증감된 금액 범위 내에서 여행요금의 증감을 상대방에게 청구할 수 있습니다.<br />
              2. 여행사는 제1항의 규정에 따라 여행요금을 증액하였을 때에는 여행출발일 15일전에 여행자에게 통지하여야 합니다.
            </p>
            <h4>[제12조] 여행조건의 변경요건 및 요금 등의 정산</h4>
            <p class="hp_pageTerms_txt">
              1. 계약서 등에 명시된 여행조건은 다음 각 호의 1의 경우에 한하여 변경될 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 여행자의 안전과 보호를 위하여 여행자의 요청 또는 현지사정에 의하여 부득이하다고 쌍방이 합의한 경우<br />
              나. 천재지변, 전란, 정부의 명령, 운송,숙박기관 등의 파업,휴업 등으로 여행의 목적을 달성할 수 없는 경우<br /><br />
            </div>
            <p class="hp_pageTerms_txt">
              2. 여행사가 계약서 등에 명시된 여행일정을 변경하는 경우에는 해당 날짜의 일정이 시작되기 전에 여행자의 서면 동의를 받아야 합니다. 이때 서면동의서에는 변경일시, 변경내용, 변경으로 발생하는 비용이 포함되어야 합니다.<br />
              3. 천재지변, 사고, 납치 등 긴급한 사유가 발생하여 여행자로부터 여행일정 변경 동의를 받기 어렵다고 인정되는 경우에는 제2항에 따른 일정변경 동의서를 받지 아니할 수 있습니다. 다만, 여행사는 사후에 서면으로 그 변경 사유 및 비용 등을 설명하여야 합니다.<br />
              4. 제1항의 여행조건 변경으로 인하여 제9조제1항의 여행요금에 증감이 생기는 경우에는 여행출발 전 변경 분은 여행출발 이전에, 여행 중 변경 분은 여행종료 후 10일 이내에 각각 정산(환급)하여야 합니다.<br />
              5. 제1항의 규정에 의하지 아니하고 여행조건이 변경되거나 제13조 내지 제15조의 규정에 의한 계약의 해제,해지로 인하여 손해배상액이 발생한 경우에는 여행출발 전 발생 분은 여행출발이전에, 여행 중 발생 분은 여행종료 후 10일 이내에 각각 정산(환급)하여야 합니다.<br />
              6. 여행자는 여행출발 후 자기의 사정으로 숙박, 식사, 관광 등 여행요금에 포함된 서비스를 제공받지 못한 경우 여행사에게 그에 상응하는 요금의 환급을 청구할 수 없습니다. 다만, 여행이 중도에 종료된 경우에는 제15조에 준하여 처리합니다.
            </p>
            <h4>[제13조] 여행자 지위의 양도</h4>
            <p class="hp_pageTerms_txt">
              1. 여행자가 개인사정 등으로 여행자의 지위를 양도하기 위해서는 여행사의 승낙을 받아야 합니다. 이때 여행사는 여행자 또는 여행자의 지위를 양도받으려는 자가 양도로 발생하는 비용을 지급할 것을 조건으로 양도를 승낙할 수 있습니다.<br />
              2. 전항의 양도로 발생하는 비용이 있을 경우 여행사는 기한을 정하여 그 비용의 지급을 청구하여야 합니다.<br />
              3. 여행사는 계약조건 또는 양도하기 어려운 불가피한 사정 등을 이유로 제1항의 양도를 승낙하지 않을 수 있습니다.<br />
              4. 제1항의 양도는 여행사가 승낙한 때 효력이 발생합니다. 다만, 여행사가 양도로 인해 발생한 비용의 지급을 조건으로 승낙한 경우에는 정해진 기한 내에 비용이 지급되는 즉시 효력이 발생합니다.<br />
              5. 여행자의 지위가 양도되면, 여행계약과 관련한 여행자의 모든 권리 및 의무도 그 지위를 양도 받는 자에게 승계됩니다.
            </p>
            <h4>[제14조] 여행사의 하자담보 책임</h4>
            <p class="hp_pageTerms_txt">
              1. 여행자는 여행에 하자가 있는 경우에 여행사에게 하자의 시정 또는 대금의 감액을 청구할 수 있습니다. 다만, 그 시정에 지나치게 많은 비용이 들거나 그 밖에 시정을 합리적으로 기대할 수 없는 경우에는 시정을 청구할 수 없습니다.<br />
              2. 여행자는 시정 청구, 감액 청구를 갈음하여 손해배상을 청구하거나 시정 청구, 감액 청구와 함께 손해배상을 청구 할 수 있습니다.<br />
              3. 제1항 및 제2항의 권리는 여행기간 중에도 행사할 수 있으며, 여행종료일부터 6개월 내에 행사하여야 합니다.
            </p>
            <h4>[제15조] 손해배상</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사는 현지여행사 등의 고의 또는 과실로 여행자에게 손해를 가한 경우 여행사는 여행자에게 손해를 배상하여야 합니다.<br />
              2. 여행사의 귀책사유로 여행자의 국외여행에 필요한 사증, 재입국 허가 또는 각종 증명서 등을 취득하지 못하여 여행자의 여행일정에 차질이 생긴 경우 여행사는 여행자로부터 절차대행을 위하여 받은 금액 전부 및 그 금액의 100%상당액을 여행자에게 배상하여야 합니다.<br />
              3. 여행사는 항공기, 기차, 선박 등 교통기관의 연발착 또는 교통체증 등으로 인하여 여행자가 입은 손해를 배상하여야 합니다. 다만, 여행사가 고의 또는 과실이 없음을 입증한 때에는 그러하지 아니합니다.<br />
              4. 여행사는 자기나 그 사용인이 여행자의 수하물 수령, 인도, 보관 등에 관하여 주의를 해태(懈怠)하지 아니하였음을 증명하지 아니하면 여행자의 수하물 멸실, 훼손 또는 연착으로 인한 손해를 배상할 책임을 면하지 못합니다.
            </p>
            <h4>[제16조] 여행출발 전 계약해제</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사 또는 여행자는 여행출발전 이 여행계약을 해제할 수 있습니다. 이 경우 발생하는 손해액은 "소비자분쟁해결기준"(공정거래위원회 고시)에 따라 배상합니다.<br />
              2. 여행사 또는 여행자는 여행출발 전에 다음 각 호의 1에 해당하는 사유가 있는 경우 상대방에게 제1항의 손해배상액을 지급하지 아니하고 이 여행계약을 해제할 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_boldTxt">1. 여행업자가 해제할 수 있는 경우</span>
              <p class="hp_pageTerms_marginLeftBox">
                가. 제12조 제1항 제1호 및 제2호 사유의 경우<br />
                나. 여행자가 다른 여행자에게 폐를 끼치거나 여행의 원활한 실시에 현저한 지장이 있다고 인정될 때<br />
                다. 질병 등 여행자의 신체에 이상이 발생하여 여행에의 참가가 불가능한 경우<br />
                라. 여행자가 계약서에 기재된 기일까지 여행요금을 지급하지 아니하는 경우
              </p>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_boldTxt">2. 여행자가 해제할 수 있는 경우</span>
              <p class="hp_pageTerms_marginLeftBox">
                가. 제12조 제1항 제1호 및 제2호 사유의 경우<br />
                나. 여행사가 제21에 따른 공제 또는 보증보험에 가입하지 아니 하였거나 영업보증금을 예치하지 않은 경우<br />
                다. 여행자의 3촌이내 친족이 사망한 경우<br />
                라. 질병 등 여행자의 신체에 이상이 발생하여 여행에의 참가가 불가능한 경우<br />
                마. 배우자 또는 직계 존비속이 신체 이상으로 3일 이상 병원 (의원)에 입원하여 여행 출발 시 까지 퇴원이 곤란한 경우 그 배우자 또는 보호자 1인<br />
                바. 여행사의 귀책사유로 계약서 또는 여행일정표(여행설명서)에 기재된 여행일정대로의 여행실시가 불가능해진 경우<br />
                사. 제10조제1항의 규정에 의한 여행요금의 증액으로 인하여 여행 계속이 어렵다고 인정될 경우
              </p>
            </div>
            <h4>[제17조] 최저행사인원 미 충족시 계약해제</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사는 최저행사인원이 충족되지 아니하여 여행계약을 해제하는 경우 여행출발 7일전까지 여행자에게 통지하여야 합니다.<br />
              2. 여행사가 여행참가자 수 미달로 전항의 기일내 통지를 하지 아니하고 계약을 해제하는 경우 이미 지급받은 계약금 환급 외에 다음 각 목의 1의 금액을 여행자에게 배상하여야 합니다.
            </p>
            <div>
              가. 여행출발 1일전까지 통지시 : 여행요금의 30%<br />
              나. 여행출발 당일 통지시 : 여행요금의 50%<br /><br />
            </div>
            <h4>[제18조] 여행출발 후 계약해지</h4>
            <p class="hp_pageTerms_txt">
              1. 여행사 또는 여행자는 여행출발 후 부득이한 사유가 있는 경우 각 당사자는 여행계약을 해지할 수 있습니다. 다만, 그 사유가 당사자 한쪽의 과실로 인하여 생긴 경우에는 상대방에게 손해를 배상하여야 합니다.<br />
              2. 제1항에 따라 여행계약이 해지된 경우 귀환운송 의무가 있는 여행사는 여행자를 귀환운송 할 의무가 있습니다.<br />
              3. 제1항의 계약해지로 인하여 발생하는 추가 비용은 그 해지사유가 어느 당사자의 사정에 속하는 경우에는 그 당사자가 부담하고, 양 당사자 누구의 사정에도 속하지 아니하는 경우에는 각 당사자가 추가 비용의 50%씩을 부담합니다.<br />
              4. 여행자는 여행에 중대한 하자가 있는 경우에 그 시정이 이루어지지 아니하거나 계약의 내용에 따른 이행을 기대할 수 없는 경우에는 계약을 해지할 수 있습니다.<br />
              5. 제4항에 따라 계약이 해지된 경우 여행사는 대금청구권을 상실합니다. 다만, 여행자가 실행된 여행으로 이익을 얻은 경우에는 그 이익을 여행사에게 상환하여야 합니다.<br />
              6. 제4항에 따라 계약이 해지된 경우 여행사는 계약의 해지로 인하여 필요하게 된 조치를 할 의무를 지며, 계약상 귀환운송 의무가 있으면 여행자를 귀환운송하여야 합니다. 이 경우 귀환운송비용은 원칙적으로 여행사가 부담하여야 하나, 상당한 이유가 있는 때에는 여행사는 여행자에게 그 비용의 일부를 청구할 수 있습니다.
            </p>
            <h4>[제19조] 여행의 시작과 종료</h4>
            <p class="hp_pageTerms_txt">
              여행의 시작은 탑승수속 (선박인 경우 승선수속)을 마친 시점으로 하며, 여행의 종료는 여행자가 입국장 보세구역을 벗어나는 시점으로 합니다. 다만, 계약내용상 국내이동이 있을 경우에는 최초 출발지에서 이용하는 운송수단의 출발시각과 도착시각으로 합니다.
            </p>
            <h4>[제20조] 설명의무</h4>
            <p class="hp_pageTerms_txt">
              여행사는 이 계약서에 정하여져 있는 중요한 내용 및 그 변경사항을 여행자가 이해할 수 있도록 설명하여야 합니다.
            </p>
            <h4>[제21조] 보험가입 등</h4>
            <p class="hp_pageTerms_txt">
              여행사는 여행과 관련하여 여행자에게 손해가 발생 한 경우 여행자에게 보험금을 지급하기 위한 보험 또는 공제에 가입하거나 영업 보증금을 예치하여야 합니다.
            </p>
            <h4>[제22조] 기타사항</h4>
            <p class="hp_pageTerms_txt">
              1. 이 계약에 명시되지 아니한 사항 또는 이 계약의 해석에 관하여 다툼이 있는 경우에는 여행사와 여행자가 합의하여 결정하되, 합의가 이루어지지 아니한 경우에는 관계법령 및 일반관례에 따릅니다.<br />
              2. 특수지역에의 여행으로서 정당한 사유가 있는 경우에는 이 표준약관의 내용과 다르게 정할 수 있습니다.
            </p>
          </div>
        </div>
        <!-- 해외여행약관  -->

        <!-- E-Mail수집거부  -->
        <div class="hp_pageTermsWrap" v-if="statusData.termsAndPoliciesID === 5">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            E-Mail수집거부
          </div>
          <div>
            <div class="hp_pageTerms_grayBoxMain">
              본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치 를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반시 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다.<br />
              정보통신망 이용촉진 및 정보보호 등에 관한 법률을 준수합니다.
            </div>
            <h4>제50조의2 (전자우편주소의 무단 수집행위 등 금지)</h4>
            <p class="hp_pageTerms_txt">
              1. 누구든지 인터넷 홈페이지 운영자 또는 관리자의 사전 동의 없이 인터넷 홈페이지에서 자동으로 전자우편주소를 수집 하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.<br />
              2. 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매ㆍ유통하여서는 아니된다.<br />
              3. 누구든지 제1항 및 제2항의 규정에 의하여 수집ㆍ판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보 전송에 이용하여서는 아니된다.
            </p>
            <h4>제74조 (벌칙)</h4>
            <p class="hp_pageTerms_txt">
              다음 각 호의 1에 해당하는 자는 1천만원 이하의 벌금에 처한다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 제8조 제4항의 규정을 위반하여 표시ㆍ판매 또는 판매할 목적으로 진열한 자<br />
              나. 제44조 의7제 1항 제1호의 규정을 위반하여 음란한 부호ㆍ문언ㆍ음향ㆍ화상 또는 영상을 배포ㆍ판매ㆍ임대하거나 공연히 전시한 자<br />
              다. 제44조 의7제 1항 제3호의 규정을 위반하여 공포심이나 불안감을 유발하는 부호ㆍ문언ㆍ음향ㆍ화상 또는 영상을 반복적으로 상대방에게 도달하게 한 자<br />
              라. 제50조 제6항의 규정을 위반하여 기술적 조치를 한 자<br />
              마. 제50조 의8의 규정을 위반하여 광고성 정보를 전송한 자 제50조의2의 규정을 위반하여 전자우편 주소를 수집ㆍ판매ㆍ유통 또는 정보전송에 이용한 자<br />
              바. 제50조 의8의 규정을 위반하여 광고성 정보를 전송한 자<br />
              사. 제53조 제4항을 위반하여 등록사항의 변경등록 또는 사업의 양도ㆍ양수 또는 합병ㆍ상속의 신고를 하지 아니한 자
            </div>
          </div>
        </div>
        <!-- E-Mail수집거부  -->

      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_hot_keyword_top10
} from '../../ETC/Axios.vue'

export default {
  name: 'Community',
  components: {
    Header,
    Footer,
    Scroll
  },
  data () {
    return {
      statusData: {
        termsAndPoliciesID: 1,
        hotKeywordData: []
      }
    }
  },
  methods: {
    setTermsAndPoliciesID (id) {
      this.statusData.termsAndPoliciesID = id
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    if (this.$route.query.termsAndPoliciesID !== undefined) {
      this.statusData.termsAndPoliciesID = +this.$route.query.termsAndPoliciesID
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/TermsAndPolicies/TermsAndPolicies.vue